export default "__VITE_ASSET__Dwy3f_Xe__"